import React from "react";
import "./WhyChoose.scss";
import team from "../../img/img1.jpg"

const WhyChoose = () => {
  return (
    <section className="why-choose">
      <div className="container">
        {/* Section Header */}
        <h2 className="section-title">Why Choose <span className="highlight">RAN GLOBAL?</span></h2>

        <div className="why-choose-content">
          {/* Image Section */}
          <div className="image-container">
            <img
                src={team} // ✅ Use curly braces to reference imported images
                alt="Our Team"
                className="team-image"
            />
            </div>

          {/* Feature List */}
          <div className="features">
            <div className="feature">
              <i className="fas fa-award icon"></i>
              <div>
                <h4>32 Years of Experience</h4>
                <p>Proven track record of delivering quality and reliability.</p>
              </div>
            </div>

            <div className="feature">
              <i className="fas fa-industry icon"></i>
              <div>
                <h4>State-of-the-Art Facilities</h4>
                <p>Equipped with advanced machinery and technology.</p>
              </div>
            </div>

            <div className="feature">
              <i className="fas fa-cogs icon"></i>
              <div>
                <h4>Customized Solutions</h4>
                <p>Tailored solutions to meet your specific requirements.</p>
              </div>
            </div>

            <div className="feature">
              <i className="fas fa-check-circle icon"></i>
              <div>
                <h4>Commitment to Quality</h4>
                <p>Stringent quality control processes at every stage.</p>
              </div>
            </div>

            <div className="feature">
              <i className="fas fa-truck icon"></i>
              <div>
                <h4>On-Time Delivery</h4>
                <p>Efficient production and logistics for timely delivery.</p>
              </div>
            </div>

            <div className="feature">
              <i className="fas fa-user-friends icon"></i>
              <div>
                <h4>Customer-Centric Approach</h4>
                <p>Dedicated team focused on exceeding customer expectations.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
